export const API_HOST =
    process.env.REACT_APP_API_HOST || "http://localhost:8000";

export const SERVER_HOST = process.env.REACT_APP_SERVER_HOST;

export const WEBSOCKET_HOST = process.env.REACT_APP_WEBSOCKET_HOST || "wss://localhost:8000/ws";
